module.exports = __webpack_public_path__ + "2b59cf9aa3e8ebe93fbfb2e0383f8af6.png";